import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  player1Life: number = 20;
  player2Life: number = 20;

  adjustedFontSize: number = 0;
  @ViewChild('player1LifeContainer') player1LifeContainer: any;

  title = 'MTG Life Counter';

  constructor() {

  }

  ngOnInit() {

    this.adjustedFontSize = 10;

    setInterval(() => {
      
      this.adjustedFontSize = this.player1LifeContainer.nativeElement.offsetHeight * 0.75;
      
    },250)
  }

  readjustFontSize() {
    this.adjustedFontSize = this.player1LifeContainer.nativeElement.offsetHeight * 0.7; 
  }

  decrementPlayer1Life() {
    this.player1Life--;
  }

  incrementPlayer1Life() {
    this.player1Life++;
  }

  decrementPlayer2Life() {
    this.player2Life--;
  }

  incrementPlayer2Life() {
    this.player2Life++;
  }
}
